import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import _ from 'lodash'
import * as mutationTypes from '../store/mutation-types'

const _import = require('./_import_' + process.env.NODE_ENV)

Vue.use(Router)

export const routes = [
  {
    path: '/login',
    component: _import('login/index'),
    props: (route) => ({
      username: route.query.username,
      next: route.query.next
    }),
    meta: {requiredToken: false}
  },
  {path: '/', component: _import('home/index')},
  {path: '/home', component: _import('home/index')},
  {path: '/payment-setting', component: _import('payment-setting/index')},
  {path: '/payment-setting/step1', component: _import('payment-setting/step1/info')},
  {path: '/payment-setting/step2', component: _import('payment-setting/step2/program')},
  {path: '/payment-setting/step3', component: _import('payment-setting/step3/dorm-goods')},
  {path: '/payment-setting/step4', component: _import('payment-setting/step4/uniforms')},
  {path: '/payment-setting/step5', component: _import('payment-setting/step5/optionals')},
  {path: '/payment-setting/step6', component: _import('payment-setting/step6/room')},
  {path: '/payment-setting/step7', component: _import('payment-setting/step7/invoice')},
  {path: '/pay', component: _import('pay/index')},
  {path: '/pay/wait-payment', component: _import('pay/wait-payment')},
  {path: '/guide', component: _import('guide/index')},
  {path: '/financial', component: _import('financial/financial-aids')},
  {path: '/documents/uniform-documents', component: _import('documents/uniform-documents')},
  {path: '/documents/uniform-size', component: _import('documents/uniform-size')},
  {path: '/documents/goods', component: _import('documents/goods')},
  {
    path: '/errors/:code',
    component: _import('errors/index'),
    props: (route) => ({code: route.params.code, message: route.query.message}),
    meta: {requiredToken: false}
  },
  {
    path: '*',
    redirect: 'errors/404',
    meta: {requiredToken: false}
  }
]

const router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  let requiredToken = _.get(to.meta, 'requiredToken', true)
  let token = store.getters.token
  if (requiredToken && _.isEmpty(token)) {
    next({path: '/login'})
  } else {
    next()
  }
})

router.afterEach(() => {
  store.commit(mutationTypes.SET_LOADING, {show: false})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js